<template>
    <div class="wrapper">
        <User-menu />
        <v-layout column class="pa-4">
            <v-breadcrumbs class=" pl-0">
                <v-icon slot="divider" aria-hidden="true" translate="no">keyboard_arrow_left</v-icon>
                <router-link to="/">
                    <v-breadcrumbs-item>
                        <v-icon class="mr-1" aria-hidden="true" translate="no">keyboard_arrow_left</v-icon> {{$t("Главная")}}
                    </v-breadcrumbs-item>
                </router-link>
            </v-breadcrumbs>
            <div>
                <v-layout row wrap align-center
                          justify-space-between mb-4
                >
                    <v-flex sm6 xs12>
                        <h1 class="section-title-main my-3 font-weight-regular">{{$t("Активность")}}</h1>
                    </v-flex>
                    <v-flex sm6 xs12>
                        <inputIcon v-model="ideas_search" class="layout row search--no-border" icon_name="search"
                                   :placeholder="$t('Поиск по разделу')"
                        />
                    </v-flex>
                </v-layout>
                <v-layout row wrap align-center
                          justify-space-between :class="{'mb-3': $vuetify.breakpoint.smAndDown, 'mb-5': $vuetify.breakpoint.mdAndUp}"
                >
                    <v-flex xs12 class="">
                        <v-tabs
                            v-model="active"
                            slot="extension"
                            color="white"
                            slider-color="red"
                            class="pr-4 tabs__bottom-border"
                        >
                            <v-tab href="#ideas" class="tabs-padding">
                                <v-layout row wrap align-center>
                                    <v-flex>{{$t("Мои идеи")}}</v-flex>
                                </v-layout>
                            </v-tab>
                            <v-tab href="#live-news" class="tabs-padding">
                                <v-layout row wrap align-center>
                                    <v-flex>{{$t("Моя живая лента")}}</v-flex>
                                </v-layout>
                            </v-tab>
                            <v-tab href="#suggestions" class="tabs-padding">
                                <v-layout row wrap align-center>
                                    <v-flex>{{$t("Мои предложения")}}</v-flex>
                                </v-layout>
                            </v-tab>
                            <router-link v-if="$vuetify.breakpoint.mdAndUp" to="live_news">
                                <buttonBdWhite v-if="active=='live-news'" class="ml-5">{{$t("Вся лента")}}</buttonBdWhite>
                            </router-link>
                        </v-tabs>
                        <router-link v-if="$vuetify.breakpoint.smAndDown" to="live_news">
                            <buttonBdWhite v-if="active=='live-news'" class="mt-3">{{$t("Вся лента")}}</buttonBdWhite>
                        </router-link>
                    </v-flex>
                </v-layout>
                <v-tabs-items v-model="active">
                    <v-tab-item id="ideas">
                        <ActivityIdeas />
                    </v-tab-item>
                    <v-tab-item id="live-news">
                        <ActivityLiveNews />
                    </v-tab-item>
                    <v-tab-item id="suggestions">
                        <ActivitySuggestions />
                    </v-tab-item>
                </v-tabs-items>
            </div>
        </v-layout>
        <v-dialog :value="ideas_bank_modal" persistent content-class="scrolled-dialog">
            <ideaModal v-if="ideas_bank_modal" />
        </v-dialog>
        <v-dialog v-model="suggest_news_modal" persistent content-class="scrolled-dialog">
            <addNewsModal v-if="suggest_news_modal" />
        </v-dialog>
    </div>
</template>

<script>
import UserMenu      from '@/components/blocks/common/User_menu.vue';
import inputIcon   from '@/components/ui/inputs/typed/input_icon';
import ideaModal from '@/components/view_blocks/Ideas_bank/Ideas_bank_modals/Ideas_bank_modal';
import buttonBdWhite from '@/components/ui/buttons/button_bd_white';
import ActivityIdeas from './Activity_ideas';
import ActivityLiveNews from './Activity_live_news';
import ActivitySuggestions from './Activity_suggestions';
import addNewsModal from '@/components/view_blocks/News_main/News_modals/modal_add_news';
import {mapGetters, mapMutations, mapActions} from 'vuex';

export default {
  components: {
    UserMenu,
    buttonBdWhite,
    inputIcon,
    ActivityIdeas,
    ActivityLiveNews,
    ActivitySuggestions,
    ideaModal,
    addNewsModal,
  },
  data() {
    return {
      // search: '',
    };
  },
  computed: {
    ...mapGetters('news_main', [
      'suggest_news_modal',
    ]),
    ...mapGetters('ideas_bank', [
      'ideas_bank_modal',
    ]),
    ...mapGetters('activity', [
      'tab',
      'search_string',
    ]),
    // search_str(){
    //   if(this.tab=='ideas'){
    //     return
    //   }
    // },
    page: {
      get() {
        return this.selected_page;
      },
      set($event) {
        return this.SET_SELECTED_PAGE($event);
      },
    },
    theme: {
      get() {
        return this.selected_theme;
      },
      set($event) {
        return this.SET_SELECTED_THEME($event);
      },
    },
    active: {
      get() {
        return this.tab;
      },
      set($event) {
        return this.SET_ACTIVE_TAB($event);
      },
    },
    ideas_search: {
      get() {
        return this.search_string;
      },
      set($event) {
        this.clear_pages();
        return this.SEARCH_ACTIVITY($event.target.value);
      },
    },
  },
  mounted() {
    this.get_activity();
  },
  methods: {
    clear_pages() {
      if (this.tab=='ideas') {
        this.CLEAR_IDEAS_PAGES();
      } else if (this.tab=='live_news') {
        this.CLEAR_FEED_PAGES();
      } else if (this.tab=='suggestions') {
        this.CLEAR_SUGGESTIONS_PAGES();
      }
    },
    ...mapMutations('ideas_bank', [
      'OPEN_MODAL',
    ]),
    ...mapMutations('activity', [
      'SET_ACTIVE_TAB',
      'SEARCH_ACTIVITY',
    ]),
    ...mapMutations('activity/ideas', [
      'CLEAR_IDEAS_PAGES',
    ]),
    ...mapMutations('activity/live_news', [
      'CLEAR_FEED_PAGES',
    ]),
    ...mapMutations('activity/suggestions', [
      'CLEAR_SUGGESTIONS_PAGES',
    ]),
    ...mapActions('activity', [
      'show_number',
      'sorting_by_date',
      'get_activity',
    ]),
  },
};
</script>

